import { ReactElement } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { Dashboard as ThirdPartyOrganizationDashboard } from './ThirdPartyOrganization/Dashboard';
import AccountStatus from '../AccountStatus/AccountStatus';
import ThirdPartyAgreementsDashboard from './ThirdPartyAgreements/Dashboard';
import UpnEsoLookup from 'pages/UPNESOLookup/UpnEsoLookup';
import WorkItemTracking from './WorkItemTracking/WorkItemTracking';
import EpicCareLinkAdministrationRoutes from './EpicCareLinkAdministration/Routes';

/**
 * Wrapping component serving as a nested router and shared for Utility components.
 *
 * @returns {ReactElement} rendered component.
 */
const Utilities = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<Route
				path={`${path}/ThirdPartyOrganization/Dashboard`}
				render={routeProps => (
					<ThirdPartyOrganizationDashboard {...routeProps} />
				)}
			/>
			<Route
				path={`${path}/ThirdPartyAgreements/Dashboard`}
				render={routeProps => (
					<ThirdPartyAgreementsDashboard {...routeProps} />
				)}
			/>
			<Route
				path={`${path}/AccountStatus`}
				render={() => <AccountStatus />}
			/>
			<Route
				path={`${path}/EmployeeInfo`}
				render={() => <UpnEsoLookup />}
			/>
			<Route
				path={`${path}/WorkItemTracking`}
				render={() => <WorkItemTracking />}
			/>
			<Route
				path={`${path}/EpicCareLink`}
				render={() => <EpicCareLinkAdministrationRoutes />}
			/>
		</Switch>
	);
};

export { Utilities };
